import { PlusOutlined } from "@ant-design/icons"
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import DangerousIcon from '@mui/icons-material/Dangerous'
import { Button, Col, Icon, Input, Row, Spin, Tooltip } from "antd"
import { error_manager } from "helper/error_manager"
import { get, post } from "helper/request"
import { Component } from "react"
import { fetchAllPatientFolders } from "redux_actions/patientfolder.state.action"

import "asset/style/patient_folder.css"

const FolderNameValidationStatus = {
    LOADING: "LOADING",
    VALID: "VALID",
    INVALID: "INVALID",
    NONE: "NONE"
}

class AddCaseButton extends Component {
    constructor(props) {
        super(props)

        this.state = {
            mode: "default",
            validStatus: FolderNameValidationStatus.NONE,
        }
    }

    createFolder = (folder_name) => {
        this.setState({ mode: "loading" })

        const url = "/api/patient_folder/"
        const data = { folder_name }

        post(url, data)
            .then(() => {})
            .catch(err => {
                error_manager("unable to create folder", err.message)
                console.error(err.message)
            })
            .finally(() => {
                fetchAllPatientFolders()
                this.setState({ mode: "default" })
            })
    }

    handlePressEnter = (e) => {
        const value = e?.target?.value
        this.createFolder(value)
    }

    handleSubmit = (value) => this.createFolder(value)

    handleOnChange = (e) => {
        const folderName = e?.target?.value
        this.setState({ validStatus: FolderNameValidationStatus.LOADING })

        if (this.validateFolderNameTimeout !== null) {
            clearTimeout(this.validateFolderNameTimeout)
            this.validateFolderNameTimeoutId = null
        }

        this.validateFolderNameTimeoutId = setTimeout(() => {
            this.validateFolderName(folderName)
        }, 500)
    }


    validateFolderName = (folder_name) => {
        const url = "/api/patient_folder/"
        const params = { folder_name, organisation: "all" }

        get(url)
            .then(data => this.setState({
                validStatus: data.count > 0 ?
                    FolderNameValidationStatus.INVALID
                    : FolderNameValidationStatus.VALID
            }))
            .catch(err => console.error(err.message))
    }

    renderFolderNameStatus = () => {
        switch (this.state.validStatus) {
            case FolderNameValidationStatus.VALID:
                return <CheckCircleIcon style={{ color: "green", paddingTop: "5px" }} />

            case FolderNameValidationStatus.INVALID:
                return (
                    <Tooltip title="Folder Name already exists">
                        <DangerousIcon style={{ color: "red", paddingTop: "5px" }} />
                    </Tooltip>
                )

            case FolderNameValidationStatus.LOADING:
                return (
                    <Spin
                        indicator={(
                            <Icon type="loading" style={{ paddingTop: "5px" }} spin />
                        )}
                    />
                )

            case FolderNameValidationStatus.NONE:
            default:
                return <></>
        }
    }

    render() {
        switch (this.state.mode) {
            case "loading":
                return (
                    <Button disabled>
                        <span>Adding...</span>
                    </Button>
                )

            case "edit":
                return (
                    <Row type="flex" gutter={4}>
                        <Col span={19}>
                            <Input.Search
                                enterButton={(<PlusOutlined />)}
                                onSearch={this.handleSubmit}
                                style={{ width: "100%" }}
                                placeholder="Type & Press Enter"
                                onChange={this.handleOnChange}
                                onPressEnter={this.handlePressEnter}
                                allowClear
                            />
                        </Col>
                        <Col span={1}>
                            {this.renderFolderNameStatus()}
                        </Col>
                    </Row>
                )

            case "default":
            default:
                return (
                    <Button onClick={() => this.setState({ mode: "edit" })}>
                        <span>New Folder</span>
                        <PlusOutlined />
                    </Button>
                )
        }
    }
}

export default AddCaseButton